// extracted by mini-css-extract-plugin
export default {"form":"Hd","inline":"Id","inputWrapper":"Jd","input":"Kd","withoutLabel":"Ld","error":"Md","label":"Nd"};